import { render, staticRenderFns } from "./FirstStep.vue?vue&type=template&id=3cb2f5f2&scoped=true"
import script from "./FirstStep.vue?vue&type=script&lang=ts"
export * from "./FirstStep.vue?vue&type=script&lang=ts"
import style0 from "./FirstStep.vue?vue&type=style&index=0&id=3cb2f5f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb2f5f2",
  null
  
)

export default component.exports